import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { FootballIcon } from "./FootballIcon";

// Bottom tab bar with the four primary tabs. Icons inlined as SVG (no deps).

const IconTrophy = () => (
  <svg viewBox="0 0 24 24">
    <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 01-10 0V4zM7 4H4v3a3 3 0 003 3M17 4h3v3a3 3 0 01-3 3" />
  </svg>
);
const IconScoreboard = () => (
  <svg viewBox="0 0 24 24">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M12 5v14M7 9h2v4H7M15 9h2v4h-2M7 16h2M15 16h2" />
  </svg>
);
const IconChart = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 19V5M4 19h17" />
    <path d="m7 15 3-4 3 2 4-7" />
    <circle cx="7" cy="15" r="1.2" />
    <circle cx="10" cy="11" r="1.2" />
    <circle cx="13" cy="13" r="1.2" />
    <circle cx="17" cy="6" r="1.2" />
  </svg>
);
const IconJersey = () => (
  <svg viewBox="0 0 24 24">
    <path d="m8 4-4 2-2 4 3 2v8h14v-8l3-2-2-4-4-2c0 2-2 3-4 3S8 6 8 4Z" />
  </svg>
);

export function TabBar() {
  return (
    <nav className="tabbar" aria-label="Primary navigation">
      <div className="tabbar__inner">
        <TabLink to="/" label="Table" end icon={<IconTrophy />} />
        <TabLink to="/matches" label="Picks" icon={<FootballIcon />} />
        <TabLink to="/results" label="Scores" icon={<IconScoreboard />} />
        <TabLink to="/stats" label="Stats" icon={<IconChart />} />
        <TabLink to="/profile" label="My Card" icon={<IconJersey />} />
      </div>
    </nav>
  );
}

function TabLink({
  to, label, icon, end = false,
}: {
  to: string; label: string; icon: ReactNode; end?: boolean;
}) {
  return (
    <NavLink to={to} end={end} aria-label={label}>
      {({ isActive }) => (
        <span className={`tabbar__item ${isActive ? "active" : ""}`}>
          {icon}
          <span>{label}</span>
        </span>
      )}
    </NavLink>
  );
}
